export const iconFontAwesomeHouseholdSoap = (
	<i className="fa-solid fa-soap"></i>
);
